import React, { useState } from 'react';
import { replace, useNavigate } from 'react-router-dom';
import { Container, Form, Button, InputGroup, Modal, Alert } from "react-bootstrap";

import { useSession } from './authentication';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export function LoginPage() {
    const navigate = useNavigate();
    const { login, loading, error } = useSession();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showError, setShowError] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const hasLoggedIn = await login(username, password);
            if (hasLoggedIn) {
                setShowError(false);
                navigate("/", { replace: true })
            }
            else {
                setShowError(true);
            }
        }
        catch { }
    };

    return (
        <Container fluid className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <Form
            onSubmit={handleLogin}
            className="p-4 rounded shadow bg-white"
            style={{ maxWidth: "400px", width: "100%" }}
            >
                <h3 className="mb-4 text-center">Spell Book</h3>

                <Form.Group className="mb-3" controlId="formUsername">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    autoComplete="username"
                    />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <InputGroup>
                        <Form.Control
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                        />
                    </InputGroup>
                </Form.Group>

                <div className="d-grid">
                    <Button variant="primary" type="submit">
                        Login
                    </Button>
                </div>

                <Alert variant="danger mt-3 mb-0 text-center" show={showError}>
                    Credenziali errate
                </Alert>
            </Form>
        </Container>
    );
}